import React from 'react';
import FeatureButton from './FeatureButton';
import AppFeatures from '../AppFeatures';

interface HandleArrivalOrderProps {
  handleAcceptOrder: (accepted: boolean) => void;
  featureValidator: (features:AppFeatures[]) => boolean;
}

const HandleArrivalOrder: React.FC<HandleArrivalOrderProps> = ({handleAcceptOrder, featureValidator}) => {
  return (
    <>
      <FeatureButton
        variant="contained"
        color="success"
        onClick={() => handleAcceptOrder(true)}
        fullWidth
        className="popup-button"
        features={[AppFeatures.AcceptOrder]}
        featureValidator={featureValidator}
      >
        Confirm details
      </FeatureButton>
      <FeatureButton
        variant="contained"
        color="error"
        onClick={() => handleAcceptOrder(false)}
        fullWidth
        className="popup-button"
        features={[AppFeatures.DenyOrder]}
        featureValidator={featureValidator}
      >
        Deny access
      </FeatureButton>
    </>
  );
};

export default HandleArrivalOrder;
